import { Box, Card, IconButton, Tooltip, Typography } from "@mui/material";

import { Info } from "@mui/icons-material";
import { colors } from "../../../style/color/colors";
import { formatToIndianCurrency } from "../../../logic/CurrencyFormatter";
import { String } from "../../../constants/Strings";
import { fonts } from "../../../style/fonts/fonts";

const TotalAssetAmountCard = ({ monthlySaving, monthlyIncome }) => {
  return (
    <Card
      sx={{
        background: colors.SecondarySummerSky,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        p: 2,
        borderRadius: 3,
      }}
    >
      <Box sx={{ mb: "30px", p: 1 }}>
        <Typography
          sx={{
            color: colors.PrimaryWhite,
            fontSize: 20,
            fontFamily: fonts.manrope,
            fontWeight: "700",
          }}
        >
          {formatToIndianCurrency(monthlySaving)}
        </Typography>
        <Box sx={{ display: "flex" }}>
          <Typography
            sx={{
              color: colors.PrimaryWhite,
              fontSize: 12,
              fontFamily: fonts.manrope,
              fontWeight: "500",
            }}
          >
            {String.Dashboard.totolAMountCardTooltip.titleMonthlysaving}
          </Typography>
          <Tooltip
            title={String.Dashboard.totolAMountCardTooltip.monthlySavingTitle}
            sx={{ position: "relative", ml: "5px" }}
            enterTouchDelay={0}
          >
            <IconButton>
              <Info
                sx={{
                  width: 12,
                  height: 12,
                  fontSize: "1rem",
                  color: colors.PrimaryWhite,
                  left: 0,
                  top: 4,
                  position: "absolute",
                  cursor: "pointer",
                }}
              />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
      <Box sx={{ mb: "30px", p: 1 }}>
        <Typography
          sx={{
            color: colors.PrimaryWhite,
            fontSize: 20,
            fontFamily: fonts.manrope,
            fontWeight: "700",
          }}
        >
          {formatToIndianCurrency(monthlyIncome)}
        </Typography>
        <Box sx={{ display: "flex" }}>
          <Typography
            sx={{
              color: colors.PrimaryWhite,
              fontSize: 12,
              fontFamily: fonts.manrope,
              fontWeight: "500",
            }}
          >
            {String.Dashboard.totolAMountCardTooltip.MonthlyIncomeTitle}
          </Typography>
          <Tooltip
            title={String.Dashboard.totolAMountCardTooltip.MonthlyIncomeTooltip}
            sx={{ position: "relative", ml: "5px" }}
            enterTouchDelay={0}
          >
            <IconButton>
              <Info
                sx={{
                  width: 12,
                  height: 12,
                  fontSize: "1rem",
                  color: colors.PrimaryWhite,
                  left: 0,
                  top: 4,
                  position: "absolute",
                }}
              />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </Card>
  );
};

export default TotalAssetAmountCard;
